import { createReducer } from '@reduxjs/toolkit'
import { AppState } from './types'
import { updateHideAssetsFlag, updateTableParams } from './actions'

const initialState: AppState = {
  tableFilter: {
    coin: '',
    hideltOneUSDTBalance: false,
  },
}

export default createReducer<AppState>(initialState, (builder) => {
  builder.addCase(updateTableParams, (state, { payload }) => {
    state.tableFilter[payload.key] = payload.value as never
  })
})
